import { Socket } from 'socket.io-client'

// Resolves true once the socket connects, or false if it fails to connect
// (error or timeout). Callers are responsible for surfacing the failure to the
// user (see the websocket exception page) so the app never hangs on a loader.
export const connectSocketAsync = (socket: Socket): Promise<boolean> => {
  return new Promise(function (resolve) {
    const cleanup = () => {
      socket.removeAllListeners('connect')
      socket.removeAllListeners('connect_error')
      socket.removeAllListeners('connect_timeout')
    }
    socket.once('connect', () => {
      cleanup()
      resolve(true)
    })
    socket.once('connect_error', () => {
      cleanup()
      resolve(false)
    })
    socket.once('connect_timeout', () => {
      cleanup()
      resolve(false)
    })
    socket.connect()
  })
}

export const getUrlOrigin = (url: string): string => {
  try {
    const urlObj = new URL(url)
    return urlObj?.origin
  } catch (error) {
    return ''
  }
}

export const getWebsocketPath = () => {
  const apiBaseUrl = new URL(process.env.PORTAL_API_BASE_URL)
  let path = apiBaseUrl.pathname
  if (!path.endsWith('/')) {
    path = `${path}/`
  }
  path = `${path}websocket/`
  return path
}
